module.exports = __webpack_public_path__ + "static/media/logo.8856e373.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 116
// module chunks = 0